/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('variant:changed', function(event) {
  var $Product = $('section.Product')
  $addtoCart = $('.ProductForm__AddToCart', $Product)
  $wholeSaleDisabledMessage = $('.ProductForm__WholeSaleDisabledMessage', $Product)
  $frameModule = $('.frame-module', $Product)

  var $Product = $('section.Product')
  if ($Product.data('is-b2b')) {
    is_b2b = true
    b2b_discount = $Product.data('b2b-discount')
    var disable_vendor = $Product.data('disable-vendor')
  }

  var variant = event.detail.variant; // Gives you access to the whole variant details

  if (self.is_b2b && (!variant || !variant.sku) || disable_vendor) { //disable add to cart if b2b and no sku on selected variant
    $addtoCart.hide()
    $frameModule.find('.ProductForm__Item').attr('disabled', 'disabled')
    $wholeSaleDisabledMessage.show()
  } else {
    $addtoCart.show()
    $frameModule.find('.ProductForm__Item').attr('disabled', null)
    $wholeSaleDisabledMessage.hide()
  }
});

var FramesModule = {
  init: function(){
    this.$container = $('.frame-module')
    this.$frameImage = $('[data-frame-image]', this.$container)
    this.$frameSelector = $('.OptionSelector [data-action="select-value"]', this.$container)
    this.$frameDropdown = $('.ProductForm__Item', this.$container)
    this.$frameValues = $('.OptionSelector .Popover__ValueList', this.$container)
    this.$frameImage = $('[data-frame-image]')
    this.$propBundle = $('input[name="properties[_bundle]"]')
    this.$addtoCart = $('.ProductForm__AddToCart', this.$container)
    this.$wholeSaleDisabledMessage = $('.ProductForm__WholeSaleDisabledMessage', this.$container)

    var $Product = $('section.Product')
    if ($Product.data('is-b2b')) {
      this.is_b2b = true
      this.b2b_discount = $Product.data('b2b-discount')
      var disable_vendor = $Product.data('disable-vendor')
    }

    var self = this

    this.frames_json = JSON.parse($('[data-frames-json]', this.$container).html())
    if (!this.frames_json) {
      return
    }

    this.active_frame = null
    this.active_frame_variant = null
    this.poster_variant = this.frames_json.poster_variant
    this.orientation = this.frames_json.orientation
    this.imagesLoaded = false

    document.addEventListener('variant:changed', function(event) {
      // Exit if event is triggered by frame selector
      if (event.detail.previousVariant.id == event.detail.variant.id) {
        console.log('hmm')
        self.setTotalPrice()
        return
      }
      var variant = event.detail.variant; // Gives you access to the whole variant details
      if (self.is_b2b && (!variant || !variant.sku) || disable_vendor) { //disable add to cart if b2b and no sku on selected variant or vendor disabled
        self.$addtoCart.hide()
        self.$wholeSaleDisabledMessage.show()
      }
      self.poster_variant = variant;
      var frame_id = self.active_frame ? self.active_frame.id : null;
      self.setActiveFrame(frame_id);
      self.setFramePrices();
    });

    this.$frameDropdown.on('click', function(){
      self.preloadImages()
    })

    this.$frameSelector.on('click', function(e){
      var frame_id = $(this).data('frame-id')
      var value = $(this).data('value')
      self.setActiveFrame(frame_id)
      self.setFrameImage()
      self.setTotalPrice()

      var wishlistSrc = document.querySelector('[data-product-data]');

      if (wishlistSrc) {
        if (!frame_id) {
          frame_id = false;
        }

        var content = JSON.parse(wishlistSrc.innerText);
        content[0].frame.id = self.active_frame_variant.id;

        wishlistSrc.innerText = JSON.stringify(content);
      }
    })

    document.addEventListener('product:added', function(event) {
      if (event.detail.is_frame) {
        return
      }
      if (self.active_frame_variant) {
        console.log(self.active_frame_variant);

        var quantity = parseInt($('.ProductForm .QuantitySelector__CurrentQuantity').val())
        var bundle_id = Math.ceil(Math.random() * 100000)
        fetch('/cart/change.js', {
          body: JSON.stringify({
            id: event.detail.key,
            "quantity": quantity,
            "properties": {
             "_bundle_id": bundle_id
           }
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (cart) {
          fetch('/cart/add.js', {
            body: JSON.stringify({
              "quantity": quantity,
              "id": self.active_frame_variant.id,
              properties: {
               "_bundle_id": bundle_id
              }
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: false,
              detail: {
                variant: self.active_frame_variant.id,
                quantity: quantity,
                is_frame: true
              }
            }))
          })

        });
      }
    });

  },
  setActiveFrame: function(frame_id){
    var self = this
    if (!frame_id) {
      self.active_frame = null
      self.active_frame_variant = null
      self.$propBundle.val(false)
      return
    }
    self.active_frame = self.findFrame(frame_id)
    self.active_frame_variant = self.findFrameVariant(self.poster_variant.title, self.active_frame.variants)
    self.$propBundle.val(true)
  },
  findFrame: function(frame_id){
    var self = this
    var frame = $.grep(self.frames_json.frames, function(f, i) {
      return f.id == frame_id;
    });
    return frame[0]
  },
  findFrameVariant: function(size, variants){
    var self = this
    var variant = $.grep(variants, function(f, i){
      //console.log(f.title + '==' + size);
      return f.title == size
    })
    return variant[0]
  },
  setFramePrices: function(){
    var self = this
    self.$frameSelector.each(function() {
      var $this = $(this)
      if ($this.data('is-frame')) {
        var frame_id = $this.data('frame-id')
        var frame = self.findFrame(frame_id)
        var frame_variant = self.findFrameVariant(self.poster_variant.title, frame.variants)
        var price = ''
        if (frame_variant) {
          price = self.Currency.formatMoney(self.calculatePrice(frame_variant.price), window.theme.moneyFormat)
          //console.log('frame size found:', frame.title)
          $this.css({'display' : 'block'})
        } else {
          $this.css({'display' : 'none'})
        }

        var value = frame.title.replace('Ramme - ', '') + ' + ' + price
        $this.html(value)
        $this.attr('data-value', value)
      }
    })
    var $selected = self.$frameSelector.filter('.is-selected')
    if (!$selected.is(':visible')) {
      $selected = self.$frameSelector.last()
      self.active_frame = null
      self.setFrameImage()
    }
    $('.ProductForm__SelectedValue', self.$container).html($selected.attr('data-value'))

    this.setTotalPrice()
  },
  setTotalPrice: function(){
    var poster_variant_price = this.is_b2b && this.poster_variant.compare_at_price > this.poster_variant.price
      ? this.poster_variant.compare_at_price
      : this.poster_variant.price
    var price_total = this.active_frame_variant
      ? this.calculatePrice(poster_variant_price) + this.calculatePrice(this.active_frame_variant.price)
      : this.calculatePrice(poster_variant_price)
    var price_total_html = this.Currency.formatMoney(price_total, window.theme.moneyFormat)
    $('.ProductMeta__Price').html(price_total_html)
    if (!this.is_b2b && this.poster_variant.compare_at_price > this.poster_variant.price) {
      var compare_price_total = this.active_frame_variant
        ? this.calculatePrice(this.poster_variant.compare_at_price) + this.calculatePrice(this.active_frame_variant.price)
        : this.calculatePrice(this.poster_variant.compare_at_price)
      var compare_price_total_html = this.Currency.formatMoney(compare_price_total, window.theme.moneyFormat)
      $('.ProductMeta__Price.Price--compareAt').html(compare_price_total_html)
    }
    $('.ProductForm__AddToCart').find('[data-money-convertible]').html(price_total_html)
  },
  setFrameImage: function(){
    this.$frameImage.removeClass('frame-module__image--visible ')
    if (!this.active_frame) {
      this.$frameImage.css('background-image', '')
      return
    }
    var img_src = this.active_frame.image
    var self = this
    setTimeout(function(){
      self.$frameImage.css('background-image', 'url('+img_src+')').addClass('frame-module__image--visible ')
    }, 300)
  },
  preloadImages: function(){
    if (this.imagesLoaded) {
      return
    }
    var images = []
    for (var i = 0; i < this.frames_json.frames.length; i++) {
      images[i] = new Image();
      images[i].src = this.frames_json.frames[i].image;
    }
    this.imagesLoaded = true
  },
  addPhotoSwipeInstance: function(instance){
    if (!this.active_frame_variant) {
      return
    }
    this.photoSwipeInstance = instance
    var self = this
    this.photoSwipeInstance.listen('imageLoadComplete', function(index, item) {
      self.onPhotoSwipeLoad(index, item)
    });
    this.photoSwipeInstance.listen('zoomGestureEnded', function(index, item) {
      self.togglePhotoSwipeZoom()
    });
    this.photoSwipeInstance.listen('doubleTap', function(index, item) {
      self.togglePhotoSwipeZoom()
    });
    this.photoSwipeInstance.listen('destroy', function(index, item) {
      self.$framePhotoSwipeImage.remove()
      document.removeEventListener('pswpTap', onSingleTap)
    });

    document.addEventListener('pswpTap', onSingleTap)

    function onSingleTap(event) {
      if (!event.detail || event.detail.pointerType === 'mouse') {
        if (event.target.classList.contains('pswp__img')) {
          self.togglePhotoSwipeZoom()
        }
      }
    }
  },
  onPhotoSwipeLoad: function(index, item){
    var $photoswipe = $('.pswp__zoom-wrap').first()
    var $newImage = this.$frameImage.clone()
    this.$framePhotoSwipeImage = $newImage
    var $photoswipeImg = $('.pswp__img')
    $newImage.css({ width: $photoswipeImg.css('width'), height: $photoswipeImg.css('height') })
    this.framePhotoSwipeImage = {
      w: item.w,
      h: item.h
    }
    $photoswipe.append($newImage)
  },
  togglePhotoSwipeZoom: function(event){
    var self = this
    if (self.$framePhotoSwipeImage.width() == self.framePhotoSwipeImage.w) {
      return
    }
    self.$framePhotoSwipeImage.hide()
    setTimeout(function(){
      self.$framePhotoSwipeImage.css({
        width: self.framePhotoSwipeImage.w + 'px',
        height: self.framePhotoSwipeImage.h + 'px'
      })
      self.$framePhotoSwipeImage.show()
    }, 500)
  },
  calculatePrice: function(price){
    if (this.is_b2b) {
      return price / this.b2b_discount
    }
    return price
  }
}

FramesModule.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = FramesModule.defaultTo(precision, 2);
      thousands = FramesModule.defaultTo(thousands, ',');
      decimal = FramesModule.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

FramesModule.defaultTo = function(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value
}

var B2BCart = {
  //novictus_api: 'https://novictus-service.eu.ngrok.io',
  novictus_api: 'https://novictus-b2b.herokuapp.com',
  namespace: '.b2bcart',
  init: function(customer_id, reInit){
    var _this = this

    this.customer_id = customer_id

    var $form = $('form.CartForm')
    if (!$form.find('[data-cart]').html()) {
      return
    }
    var cart = JSON.parse($form.find('[data-cart]').html())
    this.cart = this.mergeCart(cart)

    this.cleanCart(this.cart, function(){
      this.fetchShippingRate()
    }.bind(this))

    if (reInit) {
      return
    }

    var $createOrder = $('[data-create-order]')
    this.dropship_started = false

    var $addressForm = $('[data-register-address]')
    $('input', $addressForm).on('keyup', function(){
      $createOrder.prop('disabled', true)
      this.dropship_started = true
    }.bind(this))

    $(document).on('click', '[data-create-order]', this.createOrder.bind(this))

    document.addEventListener('cart:updated', function(){
      _this.init(_this.customer_id, true)
    })

    $(document).on('submit', '[data-register-address]', function(e){
      e.preventDefault()
      var $form = $(this)
      if ($form.data('edit')) {
        _this.registerAddress($form)
      } else {
        _this.switchAddressForm()
      }
    })
    $(document).on('change', '[data-shipping-selector-options] input', this.setShippingOption.bind(this))

  },

  mergeCart: function(cart){
    var items = []
    for (var i = 0; i < cart.additional_cart.items.length; i++) {
      var item = cart.additional_cart.items[i]
      item.item.variant = item.variant
      items.push(item.item)
    }
    var merged_cart = cart.cart
    merged_cart.items = items
    return merged_cart
  },

  cleanCart: function(cart, callback) {

    var WDNCleanCart = function (cart) {
      var remove_skus = {};
      var bundlesToRemove = [];

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (!item.sku) {
          if (item.properties._bundle_id) {
            bundlesToRemove.push(item.properties._bundle_id);
          }
          remove_skus[item.key] = 0;
        }
      }

      var findItemToRemoveByBundleId = function (id) {
        if (!id) {
          return false;
        }

        var found = cart.items.filter(function (item) {
          if (item.properties._bundle_id === id) {
            return true;
          }
        });

        if (!found[0]) {
          return false;
        }

        return found[0].key;
      };

      bundlesToRemove.forEach(function (bundle) {
        var itemKey = findItemToRemoveByBundleId(bundle);
        if (itemKey) {
          if (!remove_skus[itemKey]) {
            remove_skus[itemKey] = 0;
          }
        }
      });

      return remove_skus;
    };

    var remove_skus = WDNCleanCart(cart);

    if (Object.keys(remove_skus).length) {
      fetch("/cart/update.js", {
        body: JSON.stringify({
          updates: remove_skus,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (response) {
        alert(
          "Vi har opdateret din kurv, og fjernet produkter  pga. manglende SKU"
        );
        window.location.reload();
      });
    } else {
      callback();
    }
  },

  createOrder: function(){

    if (!this.delivery_info.quote) {
      $('.CartB2B__Error').html('You must choose a delivery option')
      $('.CartB2B__Error').show()
      return
    }

    $('.loading').addClass('show')
    $('.CartB2B__Error').hide()

    this.cart.note = $('[data-cart-note]').val()

    $.ajax({
      url: this.novictus_api + '/orders/create',
      method: 'POST',
      data: JSON.stringify({
        cart: this.cart,
        customer_id: this.customer_id,
        delivery_info: this.delivery_info,
        currency: Shopify.currency
      }),
      contentType: 'application/json'
    })
    .done(function(response){

      $('[data-create-order]').remove()
      $('.CartItem__Actions').each(function(){
        var $this = $(this)
        var quantity = $this.find('input').val()
        $this.html(quantity)
      })
      $('.CartB2B__header').html('Tak for din ordre')

      if (response.attributes.delivery_address) {
        var delivery_address = response.attributes.delivery_address
        delivery_address.company_name = delivery_address.company_name ? delivery_address.company_name : ''
        var billing_address = response.attributes.billing_address
        billing_address.company_name = billing_address.company_name ? billing_address.company_name : ''

        $('.CartB2B__order-details .Segment__Content').first().html('<span>'+delivery_address.att_contact+'</span><br>'+delivery_address.company_name+'<br>'+delivery_address.address_1+'<br>'+delivery_address.country_code+'-'+delivery_address.zip+' '+delivery_address.city+'<br>'+delivery_address.email)
        $('.CartB2B__order-details .Segment__Content').last().html('<span>'+billing_address.att_contact+'</span><br>'+billing_address.company_name+'<br>'+billing_address.address_1+'<br>'+billing_address.country_code+'-'+billing_address.zip+' '+billing_address.city+'<br>'+billing_address.email)
        $('.CartB2B__order-details').show()
      }

      $('.Cart__Address, .Cart_RegisteredAddress, [data-shipping-selector]').hide()
      $('[data-cart-note]').attr('disabled', true)

      $("html, body").animate({ scrollTop: 0 }, 600);

      $.getJSON('/cart/clear.js', function() {
      })

      $('.loading').removeClass('show')

    })
    .fail(function(error){
      console.log(error)

      if (error && error.responseJSON && error.responseJSON.message) {
        $('.CartB2B__Error').html(error.responseJSON.message)
      }
      $('.CartB2B__Error').show()
      $('.loading').removeClass('show')
    })

  },

  fetchShippingRate: function(address){
    $('.spinner-wrap').fadeIn()

    var $form = $('form.CartForm')
    if ($form.length == 0) {
      return
    }
    var _this = this
    _this.delivery_info = {}
    $('[data-shipping-selector-options]').empty()
    $('[data-shipping-selector]').hide()
    $('[data-create-order]').prop('disabled', true)
    $.ajax({
      url: this.novictus_api + '/orders/shipping_rate',
      method: 'POST',
      data: JSON.stringify({
        cart: this.cart,
        customer_id: this.customer_id,
        address: address
      }),
      contentType: 'application/json'
    })
    .done(function(response){
      $('.spinner-wrap').fadeOut()
      _this.delivery_info = {
        delivery_address: response.delivery_address,
        is_dropshipping: response.is_dropshipping,
        is_dk_dropshipping: response.is_dk_dropshipping,
        quotes: response.quotes
      }
      if (response.is_dk_dropshipping) {
        var shipping_options = ''
        $.each(response.quotes, function(idx, q){
          if (q.drop_points) {
            $.each(q.drop_points, function(idx, d){
              if (idx > 2) return
              shipping_options += _this.createShippingSelect(q, d)
            })
          } else {
            shipping_options += _this.createShippingSelect(q)
          }
        })
        $('[data-shipping-selector-options]').html(shipping_options)
        $('[data-shipping-selector]').show()
      } else {
        var price = response.quotes[0].price
        price = FramesModule.Currency.formatMoney(price * 100 * Shopify.currency.rate, window.theme.moneyFormat)
        $('[data-shipping-rate]').html(price)
        _this.delivery_info.quote = response.quotes[0]
      }
      $('[data-create-order]').prop('disabled', false)
    })
    .fail(function(error){
      console.log(error)
    })
  },

  createShippingSelect: function(quote, drop_point){
    var shipping_rate = quote.shipping_rate
    var name = drop_point
      ? shipping_rate.name + ': ' + drop_point.name
      : shipping_rate.name
    var address = drop_point
      ? '<br><small>'+drop_point.address_1+', '+drop_point.city+'</small>'
      : ''
    var drop_id = drop_point ? drop_point.drop_point_id : null
    return '<div class="Form__Item"><label for="radio-one">'+name + address +'</label><input type="radio" value="'+shipping_rate.id+'" data-drop-point="'+ drop_id+'" name="shipping" class="form-radio"></div>'
  },

  setShippingOption: function(e){
    var $input = $(e.target)
    var shipping_id = parseInt($input.val())
    var drop_point_id = $input.data('drop-point')
    var selected_quote = this.delivery_info.quotes.filter(function(q){ return q.shipping_rate.id == shipping_id })[0]
    this.delivery_info.quote = selected_quote
    if (drop_point_id) {
      var selected_drop = selected_quote.drop_points.filter(function(d){ return d.drop_point_id == drop_point_id })[0]
      this.delivery_info.drop_point = selected_drop
    } else {
      this.delivery_info.drop_point = null
    }
    $('[data-shipping-rate]').html(selected_quote.price + ' kr')
  },
  registerAddress: function($form){
    var addressObject = {}
    $.each($form.serializeArray(), function(i, v) {
     addressObject[v.name] = v.value;
    });
    this.switchAddressForm()
    this.fetchShippingRate(addressObject)
  },
  switchAddressForm: function(){
    var $form = $('[data-register-address]')
    if ($form.data('edit')) {
      $form.find('button').html('Ændre addresse')
      $form.find('input, select').each(function(){ $(this).attr('disabled', true) })
      $form.data('edit', false)
    } else {
      $form.find('button').html('Registrer adresse')
      $form.find('input, select').each(function(){ $(this).attr('disabled', false) })
      $form.data('edit', true)
      $('[data-shipping-selector]').hide()
    }
  }

}


$(document).ready(function(){
  if ($('.frame-module').length > 0) {
    FramesModule.init()
  }
})
